<script>
import { useSSRContext } from 'vue'

export default {
  methods: {
    getCurrentPath() {
      // Primero intenta obtener el contexto SSR
      const ssrContext = useSSRContext?.()
      if (ssrContext?.url) {
        return ssrContext.url
      }

      // Si no está en SSR, usa currentPath si está definido en el componente
      if (this.currentPath) {
        return this.currentPath
      }

      // Fallback al pathname del navegador en cliente
      if (typeof window !== 'undefined') {
        return window.location.pathname
      }

      return '/'
    }
  }
}
</script>